export const CommonMessages = {
  add: 'Toevoegen',
  back: 'Terug',
  cancel: 'Annuleren',
  check: 'Check',
  code: 'Code',
  comingSoon: 'Nog even geduld! We werken hard aan deze pagina.',
  confirm: 'Bevestigen',
  dashboard: 'Dashboard',
  delete: 'Verwijder',
  deliveries: 'Leveringen',
  details: 'Details',
  description: 'Omschrijving',
  disable: 'Uitschakelen',
  empty: 'Geen {items} gevonden',
  enable: 'Inschakelen',
  existing: 'Bestaand',
  from: 'Vanaf',
  goToSettings: 'Ga naar je instellingen',
  oneTime: 'Eenmalig',
  quantity: 'Aantal',
  quickFilters: 'Snelle filters',
  month: 'Maand',
  months: '0 maanden | 1 maand | {n} maanden',
  next: 'Volgende',
  new: 'Nieuw',
  no: 'Nee',
  per: 'Per',
  renew: 'Verleng',
  save: 'Opslaan',
  search: 'Zoeken',
  status: 'Status',
  submit: 'Opslaan',
  total: 'Totaal',
  type: 'Type',
  until: 't/m',
  upgrade: 'Upgrade',
  welcome: 'Welkom {name}',
  yes: 'Ja',
};
